import { render, staticRenderFns } from "./organ.vue?vue&type=template&id=61739381&"
import script from "./organ.vue?vue&type=script&lang=js&"
export * from "./organ.vue?vue&type=script&lang=js&"
import style0 from "./organ.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports